


























































































import { Component, Model, Prop, PropSync, Vue } from 'vue-property-decorator';
import { MAX_GUEST_FIELDS_CHAR } from '@/common/config';
import * as Locale from '@/plugins/i18n';

export interface TicketForm {
  name: string;
  email: string;
  description: string;
  phone: string;
}

@Component({})
export default class GuestFormContent extends Vue {
  @Model('input') readonly form!: TicketForm;
  @Prop() readonly showDescriptionBox!: boolean;
  @Prop() readonly descriptionMessage!: string;

  @PropSync('errors', { default: () => ({
    name: false,
    email: false,
    description: false,
    phone: false,
  }) }) readonly inputErrors!: {
    name: boolean;
    email: boolean;
    description: boolean;
    phone: boolean;
  };

  readonly Locale = Locale;

  loading = false;
  MAX_GUEST_FIELDS_CHAR = MAX_GUEST_FIELDS_CHAR;

  get isDescriptionExceed () {
    return this.form.description.length > MAX_GUEST_FIELDS_CHAR.description;
  }

  get descriptionPlaceholder () {
    return (
      this.descriptionMessage || Locale.i18n.t('global.describe')
    );
  }

  get buttons () {
    return [
      {
        name: Locale.i18n.t('page.guest.button.proceed'),
        id: '',
        isActive: true,
      },
    ];
  }
}
